import cx from "classnames"
import type React from "react"

import { Icon, type IconSources } from "../Icon"

export type ButtonCommonPropsType = {
  children?: React.ReactNode
  className?: string
  disabled?: boolean
  fullWidth?: boolean
  loading?: boolean
  rounded?: boolean
  size?: "large"
  iconPosition?: "left" | "right"
  icon?: IconSources
}

export type ButtonTemplatePropsType<SpecificButtonProps> = SpecificButtonProps &
  ButtonCommonPropsType

export const getButtonContent = ({
  children,
  icon,
  iconPosition = icon ? "left" : undefined,
}: Pick<ButtonCommonPropsType, "children" | "icon" | "iconPosition">) => {
  if (!children && !icon) {
    throw new Error("Either an icon or children are required")
  }

  const iconMarkup = icon ? (
    <span
      key={iconPosition}
      className={cx("cob-Button__Icon", {
        "cob-Button__Icon--left": !!children && iconPosition === "left",
        "cob-Button__Icon--right": !!children && iconPosition === "right",
      })}
    >
      <Icon source={icon} />
    </span>
  ) : null

  const leftIcon = iconPosition === "left" ? iconMarkup : null
  const rightIcon = iconPosition === "right" ? iconMarkup : null
  const childContent = children ? (
    <span key="children" className="cob-Button__content">
      {children}
    </span>
  ) : null
  return (
    <>
      {leftIcon}
      {childContent}
      {rightIcon}
    </>
  )
}

export const getButtonCommonClassNames = ({
  rounded,
  size,
  fullWidth,
  className,
  disabled,
}: Pick<
  ButtonCommonPropsType,
  "rounded" | "size" | "fullWidth" | "className" | "disabled"
>) =>
  cx(className, "cob-Button", {
    "cob-Button--rounded": rounded,
    "cob-Button--fullWidth": fullWidth,
    "cob-Button--large": size === "large",
    "cob-Button--disabled": disabled,
  })
